import React, {Component} from "react";
import translate from "../../services/translation";
import * as PropType from "prop-types";
import PropTypes from "prop-types";
import {evaluateMostSpecificSelection} from "../../services/travelAreaSelection";

export default class PrintPlannerList extends Component {

    static propTypes = {
        currentLayout: PropType.string,
        layout: PropType.string,
        filename: PropType.string,
        selectedSeason: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),
        selectedMonths: PropTypes.array,
        selectedWeekdays: PropTypes.array,
        selectedCategory: PropType.array,
        selectedType: PropType.array,
        selectedCountry: PropTypes.array,
        selectedRegion: PropTypes.array,
        selectedDestination: PropTypes.number,
        selectedDistrict: PropTypes.number,
        selectedLabel: PropTypes.string,
        selectedShipCompany: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),
        selectedShipRoute: PropTypes.string,
        selectedShipDirection: PropTypes.string,
        selectedDays: PropTypes.array,
        sortBy: PropTypes.string,
        sortDirection: PropTypes.string,
        plannerPrintBaseUrl: PropTypes.string,
        plannerPrintListUrl: PropTypes.string,
        plannerPrintTeaserUrl: PropTypes.string,
        listType: PropTypes.string,
        limit: PropTypes.number,
    };

    isAnyFilterSelected = () => {
        const {selectedSeason, selectedMonths, selectedWeekdays, selectedCategory, selectedType, selectedCountry, selectedRegion, selectedDestination, selectedDistrict,
            selectedLabel, selectedShipCompany, selectedShipRoute, selectedShipDirection, selectedDays} = this.props;

        // Filters arrive as arrays or scalar ids (0/NaN/'' when unset), and not every planner passes every prop.
        const isSet = (value) => Array.isArray(value) ? value.length > 0 : Boolean(value);

        return [
            selectedCountry, selectedRegion, selectedDestination, selectedDistrict, selectedSeason, selectedMonths, selectedWeekdays,
            selectedType, selectedCategory, selectedLabel, selectedShipCompany, selectedShipRoute, selectedShipDirection, selectedDays
        ].some(isSet);
    };

    downloadPdf = () => {
        const {currentLayout, layout, filename, selectedSeason, selectedMonths, selectedWeekdays, selectedCategory, selectedType, selectedCountry, selectedRegion, selectedDestination, selectedDistrict,
            selectedLabel, selectedShipCompany, selectedShipRoute, selectedShipDirection, selectedDays, sortBy, sortDirection, plannerPrintBaseUrl, plannerPrintListUrl, plannerPrintTeaserUrl, listType, limit} = this.props;

        let link = document.createElement('a');

        const anyFilterSelected = this.isAnyFilterSelected();

        const linkBasedOnLayout = (currentLayout === 'compare' || layout === 'compare') ? plannerPrintTeaserUrl : plannerPrintListUrl;
        // The frontend sends limit=20 hardcoded; use the actual current limit from the filter state instead.
        const limitParam = 'limit=' + (anyFilterSelected ? 999 : 20);

        // The deepest selected level wins (mirrors evaluateMostSpecificSelection's use on the
        // regular list/itinerary fetch) - OR-ing a region id together with its own parent
        // country id is a no-op in Solr (the country id already matches everything under it),
        // which silently widened the print back out to the whole country.
        const mostSpecificTravelArea = evaluateMostSpecificSelection(selectedCountry, selectedRegion, selectedDestination);
        const travelAreas = mostSpecificTravelArea ? 'travelArea=' + mostSpecificTravelArea : '';

        const travelAreaDistrict = selectedDistrict ? 'travelAreaDistrict=' + selectedDistrict : '';

        const season = listType === 'excursion' ? (selectedSeason ? 'season=' + selectedSeason : '') : selectedSeason ? 'year=' + selectedSeason : '';
        const months = selectedMonths.length > 0 ? 'month=' + selectedMonths : '';
        const weekdays = selectedWeekdays.length > 0 ? 'weekdays=' + selectedWeekdays : '';

        const type = listType === 'excursion' ? (selectedType.length > 0 ? 'excursionType=' + selectedType : '') : (selectedType.length > 0 ? 'travelType=' + selectedType : '');
        const category = listType === 'excursion' ? (selectedCategory.length > 0 ? 'excursionCategory=' + selectedCategory : '') : (selectedCategory.length > 0 ? 'travelCategory=' + selectedCategory : '');

        const label = selectedLabel ? 'travelLabel=' + selectedLabel : ''

        const shipCompany = selectedShipCompany ? 'shipCompany=' + selectedShipCompany : ''
        const shipRoute = selectedShipRoute ? 'shipRoute=' + selectedShipRoute : ''
        const shipDirection = selectedShipDirection ? 'shipDirection=' + selectedShipDirection : ''
        const shipExcursionDays = selectedDays && selectedDays.length > 0 ? 'shipExcursionDays=' + selectedDays.join(',') : ''

        const sorting = sortBy ? 'sortBy=' + sortBy + '&sortDirection=' + (sortDirection || 'asc') : ''

        const queryString = [
            travelAreas, travelAreaDistrict, type, category, label,
            shipCompany, shipRoute, shipDirection, shipExcursionDays,
            season, months, weekdays, sorting, limitParam
        ].filter(Boolean).join('&');

        const innerUrl = linkBasedOnLayout + '?' + queryString;

        link.href = plannerPrintBaseUrl + '?tx_nezzoprojecttemplate_gotenberg[url]=' +
            encodeURIComponent(innerUrl) +
            '&filename=' + filename;

        link.target = '_blank';
        link.rel = 'noopener noreferrer';

        link.dispatchEvent(new MouseEvent('click'));
    };

    render() {
        if (!this.isAnyFilterSelected()) {
            return null;
        }

        return (
            <div className="plannerLayoutBtn plannerLayoutPrint">
                <button onClick={() => this.downloadPdf()}>
                    {translate('planner_list.print')}
                </button>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Planner/PrintPlannerList.js